import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'company-bank-accounts';

const getCompanyBankAccountList = async ({ page, limit, search, orderBy }) => {
  const method = 'GET';
  const url =
    `${USE_CASE_URL}` +
    `?page=${page || null}&limit=${limit ||
      null}&search=${search}&orderBy=${orderBy}`;

  const json = await request({ method, url });
  return json;
};

export default getCompanyBankAccountList;
